import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDfpob3h04yRnIVKyRglwU89aDcdbOIaEo",
  authDomain: "firelogin-1d14f.firebaseapp.com",
  databaseURL: "https://firelogin-1d14f-default-rtdb.firebaseio.com",
  projectId: "firelogin-1d14f",
  storageBucket: "firelogin-1d14f.appspot.com",
  messagingSenderId: "531533294608",
  appId: "1:531533294608:web:4990e97575d6889e6b2e95",
  measurementId: "G-1M6YL6WHH4"
};

// Primary app — used for the logged-in admin session
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Fail fast instead of retrying a blocked download for the default ~2 minutes.
// (A blocked getBlob/getBytes usually means the bucket is missing CORS for this origin.)
storage.maxOperationRetryTime = 20000; // 20s

// Secondary app — used ONLY for createUserWithEmailAndPassword so the
// admin session is never overwritten when registering new users.
const secondaryApp = getApps().find(a => a.name === 'secondary')
  ?? initializeApp(firebaseConfig, 'secondary');
export const secondaryAuth = getAuth(secondaryApp);

export default app;